import { format } from 'date-fns';
import { aggregateModelRecords, consolidateModelNameForGrouping } from './modelColors';

/**
 * Build stacked daily model usage series: top N consolidated models + Other.
 */
export function buildModelStackFromRows(rows, _inputTopModels = [], topN = 4, padRange) {
  const dataRows = Array.isArray(rows) ? rows : [];

  const totals = new Map();
  for (const r of dataRows) {
    const norm = consolidateModelNameForGrouping(r?.model);
    totals.set(norm, (totals.get(norm) || 0) + Number(r?.events || 0));
  }

  const topNorm = Array.from(totals.entries())
    .sort((a, b) => b[1] - a[1])
    .slice(0, topN)
    .map(([norm]) => norm);

  const labelFor = (norm) => norm;

  const byDate = new Map();
  for (const r of dataRows) {
    const raw = r?.date || r?.EventDate || r?.Date;
    let d = '';
    if (raw instanceof Date) d = raw.toISOString().slice(0, 10);
    else if (typeof raw === 'string') d = raw.slice(0, 10);
    if (!d) continue;

    const norm = consolidateModelNameForGrouping(r?.model);
    const bucket = topNorm.includes(norm) ? norm : 'other';
    const ev = Number(r?.events || 0);

    const row = byDate.get(d) || { date: d };
    row[bucket] = (row[bucket] || 0) + ev;
    byDate.set(d, row);
  }

  const series = [...topNorm.map(labelFor), 'Other'];
  const chartData = Array.from(byDate.values())
    .sort((a, b) => a.date.localeCompare(b.date))
    .map((row) => {
      const out = { date: row.date };
      for (const n of topNorm) {
        const disp = labelFor(n);
        out[disp] = row[n] || 0;
      }
      out.Other = row.other || 0;
      return out;
    });

  if ((padRange && padRange.startDate && padRange.endDate) || chartData.length > 0) {
    const startStr = padRange?.startDate || chartData[0]?.date;
    const endStr = padRange?.endDate || chartData[chartData.length - 1]?.date;
    if (startStr && endStr) {
      const byDateFull = new Map(chartData.map((r) => [r.date, r]));
      const zeroTemplate = {};
      for (const s of series) zeroTemplate[s] = 0;

      const start = new Date(`${String(startStr).slice(0, 10)}T12:00:00`);
      const end = new Date(`${String(endStr).slice(0, 10)}T12:00:00`);

      const padded = [];
      for (let d = new Date(start); d <= end; d.setDate(d.getDate() + 1)) {
        const key = format(d, 'yyyy-MM-dd');
        const row = byDateFull.get(key) || { date: key, ...zeroTemplate };
        padded.push(row);
      }
      return { series, chartData: padded };
    }
  }

  return { series, chartData };
}

export { aggregateModelRecords };
